<template>
<v-app>
 <v-dialog v-model="AccessCodeFlag" persistent max-width="600px">
      <v-card>
        <v-card-title class="flex justify-center">
          <span>{{$t('labels.PleaseEnterAccessCode')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>           
            <v-card-text >
              <p style="display:flex" class="justify-center">{{ $t("labels.CliApplicationVerificationCode") }}</p>
               <v-alert type="error" v-show="showErrorAlert" outlined>{{
                  errorMessage
                }}</v-alert>
                <div
                  class="d-flex"
                  style="margin-top: 15px; margin-bottom: 15px"
                >
                  <com_six ref="sixdigit" v-model="enterAccesscode" />
                </div>
            </v-card-text>  
            <v-card-text>
              <p style="display:flex" class="justify-center">{{$t("labels.DidntGetCode")}} <span @click="resendEmailFlag = !resendEmailFlag" style="margin-left:2px" class="bLink">{{$t("InviteCoApplicant.Resend")}}</span></p>
            </v-card-text>    
            <v-card-text v-if="resendEmailFlag">
               <p style="display:flex" class="justify-center">{{$t('labels.PleaseConfirmEmail')}}</p>
               <com_Email v-model="resendEmail" /> 
            </v-card-text>       
          </v-container>
        </v-card-text>
         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="resendEmailFlag" color="blue darken-1" :disabled="resendEmail == null" text @click="resendEmailFunction">{{$t('labels.Resend')}}</v-btn>
          <v-btn v-else color="blue darken-1" :disabled="enterAccesscode == null" text @click="checkAccessCode">{{$t('labels.Submit')}}</v-btn>
          <v-btn v-if="!resendEmailFlag" color="blue darken-1" text @click="clearField">{{$t('labels.Clear')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<div class="loading" v-if="loadFlag">Loading&#8230;</div>
</v-app>
</template>

<script>
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import uiSvc from "@/services/uiService";
import com_six from "@/shared/components/sixDigit";
import com_Email from "@/shared/components/emailHome";
export default {
  components: { com_six,com_Email },
  data() {
    return {
      resendEmailFlag: false,
      resendEmail: null,
      showErrorAlert: false,
      errorMessage: null,
      AccessCodeFlag: true,
      accessCode: null,
      enterAccesscode: null,
      loadFlag: false,
      siteID: this.$route.params.siteid,
      requestDocID: this.$route.params.requestdocid,
    };
  },
  methods: {
    resendEmailFunction(){
      this.showErrorAlert = false;
       let postData = {
      SiteID: this.siteID,
      RequestDocID: this.requestDocID,
      Email: this.resendEmail
    };
     this.loadFlag = true;
    dataSvc
      .getHttp()
      .post("/api/RDResendACCESS", postData)
      .then((res) => {
        this.loadFlag = false;
        if (res.data.ReturnStatus.ReturnCode == 200) {
          this.resendEmailFlag = false;
           this.$alert(
              this.$t("Success"),
              "Access Code successfully sent"
            );  
        }else{
           this.errorMessage = "Wrong or invalid email address";
           this.showErrorAlert = true;
        }
      });
    },
    clearField() {
      this.showErrorAlert = false;
      this.enterAccesscode = null;
      this.$refs.sixdigit.Verifyclear();
    },
    nav() {
      let url = "/" + this.siteID + "/doc/" + this.requestDocID + "/upload";

      if (this.$route.query.mydeals) {
        url = url + "?mydeals=true";
      }

      this.$router.push(url);
    },
    checkAccessCode() {
      if (this.enterAccesscode == this.accessCode) {
        localStorageSvc.setAccessCode(this.enterAccesscode);
        this.nav();
        return;
      } else {
        this.errorMessage = this.$t('labels.WrongAccessCode');
        this.showErrorAlert = true;
      }
    },
  },
  created() {
    let postData = {
      SiteID: this.siteID,
      RequestDocID: this.requestDocID,
    };
    this.loadFlag = true;
    dataSvc
      .getHttp()
      .post("/api/RDACCESS", postData)
      .then((res) => {
        this.loadFlag = false;
        if (res.data.ReturnStatus.ReturnCode == 200) {
          let accessCode = res.data.AccessCode;
          if (!accessCode) {
            this.nav();
            return;
          }
          let localAccessCode = localStorageSvc.getAccessCode();
          if (localAccessCode == accessCode) {
            this.nav();
            return;
          }
          this.accessCode = accessCode;
          this.AccessCodeFlag = true;
          // this.promptAccess();
        }
      });
  },
};
</script>
